import { type FC } from 'react';
import type { TopMarketOutcomeSB } from '@mwl/core-lib';
import type { OutcomeButtonBaseOldClasses } from '@mwl/ui';
import { OutcomeButton } from '@/components/OutcomeButton/OutcomeButton';
import type { LineRowOutcomeButtonProps } from '@/types';
import { isBalancingOutcome } from './LineRowOutcomeButton.utils';
import styles from './LineRowOutcomeButton.module.scss';
export const LineRowOutcomeButton: FC<LineRowOutcomeButtonProps> = ({
  outcome,
  className,
  lineId,
  linePaused = false,
  classes,
  lineStage,
  analytics
}) => {
  if (isBalancingOutcome(outcome)) {
    return <div className={cn(styles.root, styles.oddBalance, className, classes?.balance)}>
        <span className={cn(styles.oddBalanceTitle, classes?.title)}>{outcome?.title}</span>
        <span className={cn(styles.oddBalanceValue, classes?.value)}>{outcome?.value}</span>
      </div>;
  }
  const oddClasses: OutcomeButtonBaseOldClasses = {
    empty: cn(styles.oddEmpty, classes?.empty),
    active: cn(styles.oddActive, classes?.active),
    title: cn(styles.oddTitle, classes?.title),
    value: cn(styles.oddValue, classes?.value),
    increase: cn(styles.oddIncrease, classes?.increase),
    decrease: cn(styles.oddDecrease, classes?.decrease)
  };
  return <OutcomeButton variant="vertical" className={cn(styles.root, className)} classes={oddClasses} lineId={lineId} lineStage={lineStage} outcome={(outcome as TopMarketOutcomeSB) ?? null} isFrozen={(outcome as TopMarketOutcomeSB)?.status === 'PAUSED' || linePaused} analytics={analytics} animationTimeout={1000} data-sentry-element="OutcomeButton" data-sentry-component="LineRowOutcomeButton" data-sentry-source-file="LineRowOutcomeButton.tsx" />;
};